var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wind-compass",style:(_vm.styleCompass)},[_c('span',{staticClass:"spin",style:(_vm.styleSpin)},[_c('span',{staticClass:"needle",style:(_vm.styleNeedle)})])])}
var staticRenderFns = []

export { render, staticRenderFns }